import { h } from 'preact'
import cx from 'classnames'

import styles from '../Pastander.module.css'
import s from '../Ubesvart/Ubesvart.css'

export function Quote(props: any) {
  const { parti } = props
  return (
    <svg
      class={cx(styles.decorationQuote, s.ubesvartDecorationQuote)}
      style={{ width: '2.5em', height: '0.9em' }}
      viewBox="0 0 24 19"
      aria-hidden="true"
    >
      <g
        transform="translate(-23.000000, -26.000000)"
        fill="#02B8F0"
        fill-rule="nonzero"
        style={{ fill: `${parti.farge}` }}
      >
        <path
          d="M35.775,30.9475532 C35.775,29.5783658 36.1963225,28.4770795 37.0389803,27.6436611 C37.881638,26.8102427 39.0584354,26.3935397 40.5694079,26.3935397 C42.4290663,26.3935397 43.7511474,27.0334764 44.5356908,28.3133689 C45.3202342,29.5932615 45.7125,31.0368396 45.7125,32.6441465 C45.7125,35.0848718 45.1604222,37.3618558 44.05625,39.4751668 C42.9520778,41.5884778 40.8599935,43.4189943 37.7799342,44.9667713 L36.2980263,42.4665286 C38.2739134,41.2759309 39.6541079,40.0704688 40.4386513,38.8501061 C41.2231947,37.6297434 41.6445173,36.1861654 41.7026316,34.5193285 C41.0052597,34.8765079 40.3078982,35.0550948 39.6105263,35.0550948 C38.4482398,35.0550948 37.5184245,34.6681564 36.8210526,33.8942679 C36.1236807,33.1203793 35.775,32.138151 35.775,30.9475532 Z M22.85625,30.9475532 C22.85625,29.5783658 23.2775725,28.4770795 24.1202303,27.6436611 C24.962888,26.8102427 26.1396854,26.3935397 27.6506579,26.3935397 C29.5103163,26.3935397 30.8323974,27.0334764 31.6169408,28.3133689 C32.4014842,29.5932615 32.79375,31.0368396 32.79375,32.6441465 C32.79375,35.0848718 32.2416722,37.3618558 31.1375,39.4751668 C30.0333278,41.5884778 27.9412435,43.4189943 24.8611842,44.9667713 L23.3792763,42.4665286 C25.3551634,41.2759309 26.7353579,40.0704688 27.5199013,38.8501061 C28.3044447,37.6297434 28.7257673,36.1861654 28.7838816,34.5193285 C28.0865097,34.8765079 27.3891482,35.0550948 26.6917763,35.0550948 C25.5294898,35.0550948 24.5996745,34.6681564 23.9023026,33.8942679 C23.2049307,33.1203793 22.85625,32.138151 22.85625,30.9475532 Z"
          id="”-copy-4"
          style="mix-blend-mode: multiply;"
        ></path>
      </g>
    </svg>
  )
}

export function DecorationTop(props: any) {
  const { parti } = props
  return (
    <div class={cx(styles.decorationTop, s.ubesvartDecorationTop)} aria-hidden="true">
      <svg width="169px" height="50px" viewBox="0 0 169 50">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Artboard" transform="translate(-30.000000, -39.000000)">
            <g id="Group" transform="translate(30.000000, 39.000000)">
              <polygon
                id="Path-4-Copy-12"
                fill="#ABE8FA"
                style={{ fill: `${parti.fargeSvak}` }}
                transform="translate(105.700000, 33.744192) scale(1, -1) translate(-105.700000, -33.744192) "
                points="85.825 18.240104 125.575 34.8164449 125.575 49.2482808 85.825 32.6875573"
              ></polygon>
              <polygon
                id="Path-4-Copy-13"
                fill="#ABE8FA"
                style={{ fill: `${parti.fargeSvak}` }}
                transform="translate(148.700000, 33.744192) scale(-1, -1) translate(-148.700000, -33.744192) "
                points="128.825 18.240104 168.575 34.8164449 168.575 49.2482808 128.825 32.6875573"
              ></polygon>
              <polygon
                id="Path-4-Copy-14"
                fill="#02B8F0"
                style={{ fill: `${parti.farge}` }}
                transform="translate(19.875000, 33.744192) scale(1, -1) translate(-19.875000, -33.744192) "
                points="-2.84217094e-14 18.240104 39.75 34.8164449 39.75 49.2482808 -2.84217094e-14 32.6875573"
              ></polygon>
              <polygon
                id="Path-4-Copy-15"
                fill="#02B8F0"
                style={{ fill: `${parti.farge}` }}
                transform="translate(62.700000, 33.744192) scale(-1, -1) translate(-62.700000, -33.744192) "
                points="42.825 18.240104 82.575 34.8164449 82.575 49.2482808 42.825 32.6875573"
              ></polygon>
              <polygon
                id="Path-4-Copy-17"
                fill="#02B8F0"
                style={{ fill: `${parti.farge}` }}
                transform="translate(105.700000, 15.504088) scale(1, -1) translate(-105.700000, -15.504088) "
                points="85.825 -1.59872116e-14 125.575 16.5763409 125.575 31.0081768 85.825 14.4474533"
              ></polygon>
            </g>
          </g>
        </g>
      </svg>
    </div>
  )
}

export function DecorationBottom(props: any) {
  const { parti } = props
  return (
    <div class={cx(styles.decorationBottom, s.ubesvartDecorationBottom)} aria-hidden="true">
      <svg width="89px" height="56px" viewBox="0 0 89 56">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Artboard" transform="translate(-55.000000, -278.000000)">
            <g id="Group" transform="translate(55.000000, 278.022346)">
              <polygon
                id="Path-4-Copy-10"
                fill="#02B8F0"
                style={{ fill: `${parti.farge}` }}
                points="0 20.5251397 43 39.4773328 43 55.9776536 0 37.0433163"
              ></polygon>
              <polygon
                id="Path-4-Copy-11"
                fill="#02B8F0"
                style={{ fill: `${parti.farge}` }}
                transform="translate(67.500000, 17.726257) scale(-1, 1) translate(-67.500000, -17.726257) "
                points="46 5.32907052e-14 89 18.9521932 89 35.452514 46 16.5181766"
              ></polygon>
              <polygon
                id="Path-4-Copy-16"
                fill="#ABE8FA"
                style={{ fill: `${parti.fargeSvak}` }}
                points="0 5.32907052e-14 43 18.9521932 43 35.452514 0 16.5181766"
              ></polygon>
            </g>
          </g>
        </g>
      </svg>
    </div>
  )
}

export function Snakkedurt() {
  return (
    <svg
      class={cx(styles.decorationSnakkedurt, s.ubesvartDecorationSnakkedurt)}
      width="27px"
      height="32px"
      viewBox="0 0 27 32"
      version="1.1"
      aria-hidden="true"
    >
      <g id="snakkedurt" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path
          d="M0,0 L0,31 C16.7562493,21.6654426 23.9996725,8.17688525 27,0 L0,0 Z"
          id="Fill-1-Copy"
          fill="#FFFFFF"
        ></path>
      </g>
    </svg>
  )
}
